import { v4 as uuid4 } from 'uuid';

export const regenerateBlockIds = blocks => {
  const groupIdsMap = blocks.filter(b => b.block_type === 'group').reduce((result, { uid }) => {
    result[uid] = uuid4();
    return result;
  }, {});

  return blocks.map(block => {
    const uid = groupIdsMap[block.uid] || uuid4();
    const group = groupIdsMap[block.group] || null;
    const out = { ...block, uid, group };
    if (block.block_type === 'image_grid') {
      out.items = block.items.map(item => ({ ...item, uid: uuid4() }));
    }
    return out;
  });
};
